import React, { useContext, useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdOutlinePhotoCamera } from 'react-icons/md';
import { CiEdit } from 'react-icons/ci';
import { LuLogOut } from 'react-icons/lu';
import { HiOutlineOfficeBuilding, HiOutlineUser } from 'react-icons/hi';
import { ContextUser } from '../../../providers/ContextUser';

import {
  HiOutlineMenuAlt2,
  HiOutlineX,
} from 'react-icons/hi';
import {
  Container,
  ProfileBox,
  CustomProfileImg,
  CustomDropdownToggle,
  LogoBox,
  CustomDropdownMenu,
  ToggleButtonBox,
  ToggleButton,
  AvatarFallback,
  UserMainInfo,
  UserRole,
  UserDetails,
  OrganizationInfo,
  DropdownUserHeader,
} from './styles';
import logo from '../../../assets/imgs/logo.png';
import ModalProfile from '../../modal-profile';

const Header = ({ isCollapsed, toggleSidebar }) => {
  const ctxUser = useContext(ContextUser);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const handleOpenProfile = () => setShowProfileModal(true);
  const handleCloseProfile = () => setShowProfileModal(false);

  const { handleLogout } = ctxUser;

  const renderTooltip = (expandText, collapseText) => (props) =>
    (
      <Tooltip id='button-tooltip' {...props}>
        {isCollapsed ? expandText : collapseText}
      </Tooltip>
    );

  // Função para obter as iniciais do nome
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  // Função para mapear roles para nomes amigáveis
  const getRoleDisplayName = (role) => {
    const roleMap = {
      'ADMIN': 'Administrador',
      'ACCESS_STAFF': 'Equipe de Acesso',
      'ACCESS_ORG_LEVEL': 'Nível Organizacional',
      'ACCESS_BRANCH_LEVEL': 'Nível de Secretaria',
      'ACCESS_UNIT_LEVEL': 'Nível de Unidade',
      'ACCESS_DEPARTMENT_LEVEL': 'Nível de Departamento'
    };
    return roleMap[role] || role;
  };

  // Função para obter o ícone do role
  const getRoleIcon = (role) => {
    if (role === 'ADMIN' || role === 'ACCESS_STAFF') {
      return <HiOutlineUser size={16} />;
    }
    return <HiOutlineOfficeBuilding size={16} />;
  };

  if (ctxUser === null) {
    return <>carregando</>;
  }

  return (
    <Container id='header-container'>
      <LogoBox isCollapsed={isCollapsed} id='header-logo-box'>
        <ToggleButtonBox isCollapsed={isCollapsed} id='header-toggle-button-box'>
          <OverlayTrigger
            placement='right'
            overlay={renderTooltip('Expandir', 'Recolher')}
            id='header-toggle-tooltip'
          >
            <ToggleButton onClick={toggleSidebar} id='header-toggle-button'>
              {isCollapsed ? (
                <HiOutlineMenuAlt2 size={24} />
              ) : (
                <HiOutlineX size={24} />
              )}
            </ToggleButton>
          </OverlayTrigger>
        </ToggleButtonBox>
        <img id='logo-img' src={logo} alt='Logo SOLIS' />
      </LogoBox>
      
      <ProfileBox isCollapsed={isCollapsed} id='header-profile-box'>
        <div id='header-user-info'>
          <h4 id='header-user-name'>{ctxUser?.currentUser?.name}</h4>
          <span id='header-user-email'>{ctxUser?.currentUser?.email}</span>
        </div>

        <Dropdown id='header-user-dropdown'>
          <CustomDropdownToggle variant='ligth' id='user-avatar-dropdown-toggle'>
            {ctxUser?.currentUser?.imageUrl ? (
              <CustomProfileImg
                id='user-avatar-image'
                src={ctxUser?.currentUser?.imageUrl}
                alt='Imagem Usuário'
              />
            ) : (
              <AvatarFallback id='user-avatar-fallback'>
                {getInitials(ctxUser?.currentUser?.name)}
              </AvatarFallback>
            )}
          </CustomDropdownToggle>

          <CustomDropdownMenu id='user-avatar-dropdown-menu'>
            <DropdownUserHeader id='dropdown-user-header'>
              <div id='dropdown-user-name'>{ctxUser?.currentUser?.name}</div>
              <div id='dropdown-user-role'>{getRoleDisplayName(ctxUser?.currentUser?.role)}</div>
              <div id='dropdown-user-email'>{ctxUser?.currentUser?.email}</div>
            </DropdownUserHeader>
            <Dropdown.Divider />
            <Dropdown.Item href='#' id='user-profile-menu-item' onClick={handleOpenProfile}>
              <span id='user-profile-open-button'>
                <CiEdit /> Meu perfil...
              </span>
            </Dropdown.Item>
            <Dropdown.Item href='#' id='user-logout-option'>
              <span onClick={handleLogout} id='user-logout-button'>
                <LuLogOut /> Sair
              </span>
            </Dropdown.Item>
          </CustomDropdownMenu>
        </Dropdown>
      </ProfileBox>
      <ModalProfile id='modal-profile-root' isOpen={showProfileModal} onClose={handleCloseProfile} />
    </Container>
  );
};

export default Header;
